@use 'src/core/styles/mediaQueries';

.banner[data-theme='default'] {
  --bg-color-success: #5eb273;
  --color-success: var(--white-100);
  --bg-color-warning: #ffc149;
  --color-warning: var(--dark-blue-500);
  --bg-color-error: #cd5437;
  --color-error: var(--white-100);
}

.banner {
  z-index: 5;
  padding: 1em;

  &.sticky {
    position: sticky;
    top: var(--navbar-header-height);
  }

  &.success {
    background-color: var(--bg-color-success);
    color: var(--color-success);
  }

  &.warning {
    background-color: var(--bg-color-warning);
    color: var(--color-warning);
  }

  &.error {
    background-color: var(--bg-color-error);
    color: var(--color-error);
  }

  .bannerContentContainer {
    display: flex;
    text-align: center;

    .bannerContent {
      flex-grow: 1;
    }

    .bannerDismissBtn {
      margin-left: 4px;
      float: right;
      line-height: 0;
    }
  }
}
